export default __webpack_public_path__ + "static/media/Grimjaw Jerkin.786df084.jpg";